module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "tx"
  }, [_c('br'), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "toch"
  }, [_c('b', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('br'), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    staticStyle: {
      "margin-top": "4em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/book1#fn1",
      "id": "en1"
    }
  }, [_c('i', [_vm._v("Book One")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/book1#fn1"
    }
  }, [_vm._v("THE MIDNIGHT READER")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/pastoral_care#fn2",
      "id": "en2"
    }
  }, [_vm._v("PASTORAL CARE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/the_ravages#fn3",
      "id": "en3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE RAVAGES OF SPRING")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/the_temptation#fn4",
      "id": "en4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE TEMPTATION OF ST. IVO")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/the_warden#fn5",
      "id": "en5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE WARDEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/john_napper#fn6",
      "id": "en6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JOHN NAPPER SAILING THROUGH THE UNIVERSE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/book2#fn7",
      "id": "en7",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Book Two")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/book2#fn7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TALES OF QUEEN LOUISA")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/queen_louisa#fn8",
      "id": "en8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("QUEEN LOUISA")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/king_gregor#fn9",
      "id": "en9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("KING GREGOR AND THE FOOL")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/muriel#fn10",
      "id": "en10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MURIEL")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/book3#fn11",
      "id": "en11",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Book Three")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/book3#fn11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE KING’S INDIAN")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/book3#fn12",
      "id": "en12",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("A Tale")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/bio",
      "id": "bio",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("A Biography of John Gardner")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21784071","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 69
// module chunks = 0